import * as React from 'react';
import { IDataEntity, IColumnMap, IGroupedRow, IAppParams } from '../../models';
import { safe, getValueFromStringNotation, getDisplayValue, isNullOrUndefined, getCurrencySymbol, getShareDocumentByType } from "../../utils";
import { Tooltip } from "../../assets/Tooltip/Tooltip";
import * as moment from "moment";

const styles = require('../FundPages/Fundpages.pcss');
const internalStyles = require('./ExplorerTabContent.pcss');
const cardTooltips = require('./overrides/cardTooltips.pcss');

interface IState {
    showTooltip?: boolean;
}

interface IProps {
    column?:
    IColumnMap;
    row?: IDataEntity;
    groupedRow?: IGroupedRow;
    isPPL?: boolean;
    appParams?: IAppParams;
}

export class CardRow extends React.Component<React.Props<{}> & IProps, IState>{
    constructor(props) {
        super(props);
        this.state = {
            showTooltip: false
        };
        this.toggleTooltip = this.toggleTooltip.bind(this);

    }

    toggleTooltip() {
        let { showTooltip } = this.state;
        this.setState({ showTooltip: !showTooltip });
        //toggleRows(fund.clientCode);
    }

    checkDocument(type) {
        let { row, appParams } = this.props;
        return getShareDocumentByType(row, appParams, type);
    }

    render() {
        let { column, row, groupedRow, isPPL } = this.props;
        let { className } = column;
        let { showTooltip } = this.state;

        let colSpan = column.colSpan || 1;
        let value;

        if (column.type === 'component') {
            value = React.cloneElement(column.component, column.getPropsFn(row, groupedRow));
            if (!isNullOrUndefined(value.props.stars) && value.props.stars === 0) {
                return null;
            }
            if (!isNullOrUndefined(value.props.documents)) {
                if (value.props.type !== "MR") {
                    let documentUrl = this.checkDocument(value.props.type);
                    if (isNullOrUndefined(documentUrl) || documentUrl === "-") {
                        return null;
                    }
                }
            }
        }
        else if (column.type === 'custom') {
            value = column.customJsx;
        }
        else if (column.entity === "fund") {
            value = getValueFromStringNotation(column.field, groupedRow);
            value = getDisplayValue(value, column);
        }
        else {
            if (isNullOrUndefined(column.isPropertyAssetClass)) {
                value = getValueFromStringNotation(column.field, row);
                value = getDisplayValue(value, column);
            }
            else {
                let isProperty = groupedRow.fund.properties["asset_class"] === "Property" || row.properties.fund_key === "HIT";
                if (column.isPropertyAssetClass) {
                    if (isProperty && !isPPL) {
                        return null;
                    }
                    else {
                        value = getValueFromStringNotation(column.field, row);
                        value = getDisplayValue(value, column);
                    }
                }
                else {
                    if (!isProperty && !isPPL) {
                        return null;
                    }
                    else {
                        if (column.fields) {
                            let values = column.fields.map(item => getDisplayValue(getValueFromStringNotation(item, row), column));
                            value = values.join(column.fieldSeperator);
                        } else {
                            value = getValueFromStringNotation(column.field, row);
                            value = getDisplayValue(value, column);
                        }
                    }
                }
            }
        }

        let currencySymbol = safe(() => getCurrencySymbol(row["properties"]["currency"] as string), { isMajor: false, value: "" });

        if ((column.headerKey === "Price" || column.headerKey === "Bid / Offer Prices") && value !== "n/a") {
            if (value.indexOf(" / ") === -1) {
                value = `${currencySymbol.isMajor ? `${currencySymbol.value}` : ""} ${value} ${currencySymbol.isMajor ? "" : `${currencySymbol.value}`}`;
            } else {
                let valueArr = value.split(" / ");
                value = valueArr.map(item => `${currencySymbol.isMajor ? `${currencySymbol.value}` : ""} ${item} ${currencySymbol.isMajor ? "" : `${currencySymbol.value}`}`).join(" / ");
            }
        }

        if (column.isPerformance) {
            value = `${value}%`;
        }

        let label = "";
        return (
            <div className={`${className} ${internalStyles.mobileRow}`} >
                {(() => {
                    if (!column.hideHeader) {
                        if (column.isPerformance && column.headerKey.indexOf("\n") >= 0) {
                            let headerKeyArr = column.headerKey.split("\n");
                            label = `From ${headerKeyArr[0]} to ${headerKeyArr[1]}`;
                        }
                        else {
                            label = column.headerKey;
                        }

                        return <span className={internalStyles.mobileTitle}>{label}</span>;
                    }
                })()}
                {(() => {
                    if (column.tooltip && !column.tooltip["is_deleted"]) {
                        return <Tooltip onClick={this.toggleTooltip} text={column.tooltip["disclaimer"]} />
                    }
                })()}
                <span className={internalStyles.mobileValue}>{!column.isParentHeader ? value : ""}</span>
                {(() => {
                    if (showTooltip) {
                        return (
                            <div className={`${styles.clearFix} ${styles.tooltipText}`}>
                                {column.tooltip}
                            </div>
                        );
                    }
                })()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/components/ExplorerTabContent/CardRow.tsx